export default __webpack_public_path__ + "static/media/omnitelLogo.5a73b58a.png";